<template>
  <v-container>
    <v-row class="document-row" v-if="showDocument">
      <v-col class="document-item" v-for="(item, index) in documentList" :key="item.id + index">
        <v-card
            tile
            :class="isActiveDocument === item.id ? 'active pa-2 offer-card' : 'pa-2 offer-card'"
            @click="selectOffer(item)"
            :disabled="disabled"
        >
          <v-card-text class="text-center">
            <pdf
                ref="pdf"
                v-if="item.fileType === 'application/pdf'"
                :src="item.src"
                class="pdf docu-preview"
            />
            <div style="height: 136px;" v-else-if="item.fileType === 'image/jpeg' || item.fileType === 'image/png'">
              <v-img
                  :src="item.src"
                  contain
                  max-height="136"
              />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Utils from '@/modules/core/services/utils';
import DocumentationService from '@/modules/core/services/documentation-service';

export default {
  name: 'DocumentLineViewer',
  props: {
    taskInfo: {},
    service: {},
    disabled: Boolean
  },
  components: {
    pdf: () => import('vue-pdf')
  },
  data() {
    return {
      documentList: [],
      translatedDocuCount: 0,
      activeDocument: null
    }
  },
  computed: {
    showDocument() {
      return this.documentList.length > 0 && this.documentList.length === this.translatedDocuCount;
    },
    isActiveDocument() {
      return this.activeDocument;
    }
  },
  methods: {
    setActiveDocument(activeDocumentId) {
      this.activeDocument = activeDocumentId;

      if (!activeDocumentId && this.documentList.length > 0) {
        this.activeDocument = this.documentList[0].id;
        this.$emit('selectedOffer', this.documentList[0]);
      } else if(activeDocumentId) {
        for (let item of this.documentList) {
          if (activeDocumentId === item.id) {
            this.$emit('selectedOffer', item);
            break;
          }
        }
      }
    },
    loadDocuments() {
      if (!this.service || !this.taskInfo || !this.taskInfo.id) {
        return;
      }

      this.service.readAllDocuments(this.taskInfo.id,
          (response) => {
            this.documentList = response.data;
            this.documentList.forEach((documentation) => this.loadStaticFile(documentation));
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:documentation_plural')}));
          }
      )
    },
    selectOffer(item) {
      this.activeDocument = item.id;
      this.$emit('selectedOffer', item);
    },
    loadStaticFile(document) {
      this.translatedDocuCount++;
      DocumentationService.getDocByTypeAndId(
          document.id,
          document.fileType,
          document.documentType,
          document.task,
          (fileUrl) => {
            document.src = fileUrl;
          },
          () => {
          }
      )
    },
    getDocumentList() {
      return this.documentList;
    },
    clearData() {
    }
  },
  mounted() {
    if (!!this.taskInfo && !!this.taskInfo.id) {
      this.loadDocuments();
    }
  }
}
</script>

<style lang="scss">

.document-row {
  border: 1px solid #444444;
  border-radius: 5px;
  min-height: 300px;
  flex-wrap: nowrap;
  overflow-x: auto;

  .document-item{
    max-height: 200px;
    max-width: 200px;
    margin-right: 10px;

    .offer-card {
      padding: 0;
      min-width: 200px;

      &.active {
        border: 1px solid var(--v-primary-base);
        border-color: #1cb1eb;
        background: rgb(30, 30, 30, 0.2);
      }
    }
  }


}
</style>